// extracted by mini-css-extract-plugin
export var fullWidthButton = "_ex-0";